////////////////////////////////////////////////////////////////////////////////
// Dom Ready Listener
////////////////////////////////////////////////////////////////////////////////

/**
 * Because script files should always be render blocked; natively listening for
 * dom ready is pretty much pointless. However, if you still want to run stuff
 * at a specific time (like when render blocked files are all loaded), you can
 * manually update the dom status and run cached methods with this.
 *
 * A intended use case would be where you load 10 javascript files, and you call
 * a function in the second file that won't exist until the ninth file is loaded.
 * This will run any dom.ready(...) functions only when the loaded status is updated.
 *
 * @see https://stackoverflow.com/a/37403125/843131
 *
 * @author Mark Notton <mark@marknotton.uk>
 *
 * @license Copyright 2019 Mark Notton
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const dom = {
  functions : [],
  triggered : false,

  /**
   * Stores a function that will be triggered when dom status is changed to 'loaded'
   * @method  ready
   * @param   {Function} func The function you want to call.
   * @example
   * dom.ready(() => {
   *   console.log("All DOM elements and script files loaded.")
   * });
   */

  ready : (func) => dom.functions.push(func),

  /**
   * Update the dom status manually to trigger all stored methods
   * @method  status
   * @param   {String} val Only listens for 'loaded' string
   * @example dom.status = 'loaded';
   */

  set status(val) {
    if (!dom.triggered) {
      loaded = val;
      dom.triggered = true;
      if (loaded == 'loaded') {
        dom.functions.forEach((func) => {
          func()
        });
      }
    }
  }
};
